<!-- <mat-form-field appearance="outline" class="registration-year">
  <mat-label>Select Registration Date</mat-label>
  <input
    tabindex="1"
    matInput
    #registrationInput
    id-automation="registration_year_id"
    [matDatepicker]="registrationYear"
    placeholder="Month and Year"
    formControlName="registration_date"
    [min]="minDate"
    [max]="maxDate"
    appMmYyyyformat
    [readonly]="true"
    (click)="registrationYear.open()"
    (keyup.enter)="EnterKey($event)"
  />
  <mat-datepicker-toggle matSuffix [for]="registrationYear">
    <mat-icon matDatepickerToggleIcon>
      <img
        src="assets/icon/calendar.svg"
        class="cursor-pointer mb-2"
        alt="calendar"
      />
    </mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker
    #registrationYear
    startView="multi-year"
    id-automation="datepicker_registration_year_id"
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event, registrationYear)"
  >
  </mat-datepicker>
</mat-form-field> -->

<mat-form-field
  appearance="outline"
  class="registration-year"
  [ngClass]="
    visuallyDisabledFields['registration_date'] ? 'visually-disabled' : ''
  "
>
  <mat-label>Select Registration Date</mat-label>
  <input
    matInput
    tabindex="1"
    #registrationInput
    id-automation="registration_year_id"
    [matDatepicker]="registrationYear"
    formControlName="registration_date"
    appDateFormat
    [min]="minDate"
    [max]="maxDate"
    (click)="
      !visuallyDisabledFields['registration_date'] && registrationYear.open()
    "
    (keyup.enter)="
      !visuallyDisabledFields['registration_date'] && EnterKey($event)
    "
    [matDatepickerFilter]="dateFilter"
    [readonly]="visuallyDisabledFields['registration_date']"
    [disabled]="disabledRegistrationYear"
    [ngClass]="disabledRegistrationYear ? 'visually-disabled' : ''"
  />
  <mat-datepicker-toggle matSuffix [for]="registrationYear"
    ><mat-icon matDatepickerToggleIcon disabled="disabledRegistrationYear">
      <img
        src="assets/icon/calendar.svg"
        class="cursor-pointer mb-2"
        alt="calendar"
      />
    </mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker
    #registrationYear
    id-automation="datepicker_registration_year_id"
    startView="multi-year"
    [disabled]="disabledRegistrationYear"
  ></mat-datepicker>
  <mat-error *ngIf="form.controls['registration_date']?.hasError('required')">
    This is a required field.
  </mat-error>

  <mat-error
    *ngIf="
      form.get('registration_date')?.touched &&
      form.get('registration_date')?.hasError('invalid')
    "
  >
    <!-- Please enter a valid date. -->
  </mat-error>
</mat-form-field>
